// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';

// Internal Dependencies
import MText from '../common/MText';
import Colours from '../../styles/colours';
import { IsEmpty } from '../../common/checks';

const ContriPoiTextField = ({ label, children, value }) => (
  <div className="form-group">
    <MText text={label} semibold colour={Colours.Gray6} />
    <div className="border rounded p-3 bg-light" style={{ minHeight: '45px' }}>
      {
        !IsEmpty(children)
          ? children
          : <MText text={value} colour={Colours.Gray6} style={{ height: '18px' }} />
      }
    </div>
  </div>
);

ContriPoiTextField.propTypes = {
  label:    PropTypes.string.isRequired,
  value:    PropTypes.string,
  children: PropTypes.node,
};

ContriPoiTextField.defaultProps = {
  value:    '',
  children: null,
};

export default ContriPoiTextField;
